export enum PrimerSelectCategoryLabelEnum {
    RECENT_PRIMERS = 'orders.setup.primerManagement.recentPrimers',
    CUSTOM_PRIMERS = 'orders.setup.primerManagement.customPrimers',
    STANDARD_PRIMERS = 'orders.setup.primerManagement.standardPrimers',
}
